import { RoutersType } from "../type/routes";
import SCRC010001 from "../pages/SCRC010001";
import SCRC030001 from "../pages/SCRC030001";
import SCRC030102 from "../pages/SCRC030102";
import SCRC040004 from "../pages/SCRC040004";
import SCRC040101 from "../pages/SCRC040101";
import SCRC040106 from "../pages/SCRC040106";
import SCRC040103 from "../pages/SCRC040103";
import SCRC070008 from "../pages/SCRC070008";
import SCRC050017 from "../pages/SCRC050017";
import SCRC050009 from "../pages/SCRC050009";
import SCRC050101 from "../pages/SCRC050101";
import SCRC050102 from "../pages/SCRC050102";
import SCRC050107 from "../pages/SCRC050107";
import SCRC050106 from "../pages/SCRC050106";
import SCRC050115 from "../pages/SCRC050115";
import SCRC060007 from "../pages/SCRC060007";
import SCRC060116 from "../pages/SCRC060116";
import SCRC060103 from "../pages/SCRC060103";
import SCRC060105 from "../pages/SCRC060105";
import SCRC020001 from "../pages/SCRC020001";
import SCRC080009 from "../pages/SCRC080009";
import SCRC010004 from "../pages/SCRC010004";
import SCRC050030 from "../pages/SCRC050030";
import SCRC080006 from "../pages/SCRC080006";
import SCRC080105 from "../pages/SCRC080105";
import SCRC080001 from "../pages/SCRC080001";
import SCRC060033 from "../pages/SCRC060033";
import SCRC060111 from "../pages/SCRC060111";
import SCRC080002 from "../pages/SCRC080002";
import SCRC080103 from "../pages/SCRC080103";
import SCRC060101 from "../pages/SCRC060101";
import SCRC070104 from "../pages/SCRC070104";
import SCRC060110 from "../pages/SCRC060110";
import SCRC060108 from "../pages/SCRC060108";
import SCRC060132 from "../pages/SCRC060132";
import SCRC060118 from "../pages/SCRC060118";
import SCRC050125 from "../pages/SCRC050125";
import SCRC050018 from "../pages/SCRC050018";
import SCRC050103 from "../pages/SCRC050103";
import SCRC050016 from "../pages/SCRC050016";
import SCRC050110 from "../pages/SCRC050110";
import SCRC050012 from "../pages/SCRC050012";
import SCRC060102 from "../pages/SCRC060102";
import SCRC070002 from "../pages/SCRC070002";
import SCRC050126 from "../pages/SCRC050126";
import SCRC050111 from "../pages/SCRC050111";
import SCRC060009 from "../pages/SCRC060009";
import SCRC060123 from "../pages/SCRC060123";
import SCRC050114 from "../pages/SCRC050114";
import SCRC050029 from "../pages/SCRC050029";
import SCRC050019 from "../pages/SCRC050019";
import SCRC060119 from "../pages/SCRC060119";
import SCRC070105 from "../pages/SCRC070105";
import SCRC050120 from "../pages/SCRC050120";
import SCRC070003 from "../pages/SCRC070003";
import SCRC070007 from "../pages/SCRC070007";
import SCRC050121 from "../pages/SCRC050121";
import SCRC060104 from "../pages/SCRC060104";
import SCRC060114 from "../pages/SCRC060114";
import SCRC050105 from "../pages/SCRC050105";
import SCRC050123 from "../pages/SCRC050123";
import SCRC060127 from "../pages/SCRC060127";
import SCRC050104 from "../pages/SCRC050104";
import SCRC060115 from "../pages/SCRC060115";
import SCRC050113 from "../pages/SCRC050113";
import SCRC060106 from "../pages/SCRC060106";
import SCRC080104 from "../pages/SCRC080104";
import SCRC040002 from "../pages/SCRC040002";
import SCRC060129 from "../pages/SCRC060129";
import SCRC060124 from "../pages/SCRC060124";
import SCRC060017 from "../pages/SCRC060017";
import SCRC080008 from "../pages/SCRC080008";
import SCRC050108 from "../pages/SCRC050108";
import SCRC050122 from "../pages/SCRC050122";
import SCRC050024 from "../pages/SCRC050024";
import SCRC020002 from "../pages/SCRC020002";
import SCRC060121 from "../pages/SCRC060121";
import SCRC010002 from "../pages/SCRC010002";
import SCRC060130 from "../pages/SCRC060130";
import SCRC060120 from "../pages/SCRC060120";
import SCRC060122 from "../pages/SCRC060122";
import SCRC060134 from "../pages/SCRC060134";
import SCRC080007 from "../pages/SCRC080007";
import SCRC060013 from "../pages/SCRC060013";
import SCRC060112 from "../pages/SCRC060112";
import SCRC070101 from "../pages/SCRC070101";
import SCRC070206 from "../pages/SCRC070206";
import SCRC100004 from "../pages/SCRC100004";

/**
 * アプリケーションのルートオブジェクトの配列です。
 * @typedef {Object} RoutersType
 * @property {string} name - ルートの名前。
 * @property {string} path - ルートのパス。
 * @property {React.ComponentType} component - ルートにレンダリングするコンポーネント。
 */
const routes: RoutersType[] = [
  {
    name: "ログイン",
    path: "/SCRC010001",
    component: SCRC010001,
    meta: {
      title: "ログイン",
    },
  },
  /**
   * 社会福施設職員等退職手当共済制度　共済契約のお申込みのルート情報
   */
  {
    name: "社会福施設職員等退職手当共済制度　共済契約のお申込み",
    path: "/SCRC030001",
    component: SCRC030001,
    meta: {
      title: "社会福施設職員等退職手当共済制度　共済契約のお申込み",
      contextName: "job_01,searchForHistory",
    },
  },

  {
    name: "新規契約情報入力（法人情報）",
    path: "/SCRC030102",
    component: SCRC030102,
    meta: {
      title: "新規契約情報入力（法人情報）",
      contextName: "job_01",
    },
  },
  {
    name: "「俸給の調整額」新規申請",
    path: "/SCRC040004",
    component: SCRC040004,
    meta: {
      title: "「俸給の調整額」新規申請",
      contextName: "job_07,job_08,job_32,agentRequest,searchForHistory",
    },
  },
  {
    name: "契約者照会",
    path: "/SCRC040101",
    component: SCRC040101,
    meta: {
      title: "契約者照会",
    },
  },

  {
    name: "契約者・法人担当者情報の確認・変更",
    path: "/SCRC040106",
    component: SCRC040106,
    meta: {
      title: "契約者・法人担当者情報の確認・変更",
    },
  },
  {
    name: "「俸給の調整額」登録済及び登録非該当手当一覧",
    path: "/SCRC040103",
    component: SCRC040103,
    meta: {
      title: "「俸給の調整額」登録済及び登録非該当手当一覧",
      contextName: "job_07,job_08,job_32,agentRequest",
    },
  },
  {
    name: "提出完了",
    path: "/SCRC070008",
    component: SCRC070008,
    meta: {
      title: "提出完了",
    },
  },
  {
    name: "施設情報の変更登録",
    path: "/SCRC050017",
    component: SCRC050017,
    meta: {
      title: "施設情報の変更登録",
      contextName: "job_17,job_11,searchForHistory",
    },
  },
  {
    name: "契約解除（経営者でなくなった）入力内容確認",
    path: "/SCRC050009",
    component: SCRC050009,
    meta: {
      title: "契約解除（経営者でなくなった）入力内容確認",
      contextName: "job_02,searchForHistory",
    },
  },
  {
    name: "施設情報　新規登録",
    path: "/SCRC050101",
    component: SCRC050101,
    meta: {
      title: "施設情報　新規登録",
      contextName: "job_01,job_11,job_15",
    },
  },
  {
    name: "新規契約情報入力（施設情報）一覧",
    path: "/SCRC050102",
    component: SCRC050102,
    meta: {
      title: "新規契約情報入力（施設情報）一覧",
      contextName: "job_01",
    },
  },
  {
    name: "契約解除（経営者でなくなった）対象施設一覧",
    path: "/SCRC050107",
    component: SCRC050107,
    meta: {
      title: "契約解除（経営者でなくなった）対象施設一覧",
      contextName: "job_02",
    },
  },
  {
    name: "契約解除（経営者でなくなった）内容入力",
    path: "/SCRC050106",
    component: SCRC050106,
    meta: {
      title: "契約解除（経営者でなくなった）内容入力",
      contextName: "job_02,job_18",
    },
  },
  {
    name: "直近3ヶ月の退職者一覧",
    path: "/SCRC050115",
    component: SCRC050115,
    meta: {
      title: "直近3ヶ月の退職者一覧",
      contextName: "job_03,job_04,job_16,searchForHome",
    },
  },
  {
    name: "新規契約申込提出確認",
    path: "/SCRC060007",
    component: SCRC060007,
    meta: {
      title: "新規契約申込提出確認",
      contextName: "job_01,searchForHistory",
    },
  },
  {
    name: "職員一覧　本俸月額更新",
    path: "/SCRC060116",
    component: SCRC060116,
    meta: {
      title: "職員一覧　本俸月額更新",
      contextName: "job_11,job_32,agentRequest,searchForHistory",
    },
  },
  {
    name: "職員一覧　配置換え登録",
    path: "/SCRC060103",
    component: SCRC060103,
    meta: {
      title: "職員一覧　配置換え登録",
      contextName: "job_11,job_27,agentRequest,searchForHistory",
    },
  },
  {
    name: "職員一覧　配置換え確認",
    path: "/SCRC060105",
    component: SCRC060105,
    meta: {
      title: "職員一覧　配置換え確認",
      contextName: "job_11,job_27,agentRequest",
    },
  },
  {
    name: "退職情報　登録（退職者の基本情報登録）",
    path: "/SCRC060127",
    component: SCRC060127,
    meta: {
      title: "退職情報　登録（退職者の基本情報登録）",
      contextName: "job_32,job_27,retirement,agentRequest",
    },
  },
  {
    name: "原簿閲覧請求",
    path: "/SCRC070206",
    component: SCRC070206,
    meta: {
      title: "原簿閲覧請求",
      contextName: "job_44,searchForHistory",
    },
  },
  {
    name: "共済契約者ホーム",
    path: "/SCRC020001",
    component: SCRC020001,
    meta: {
      title: "共済契約者ホーム",
    },
  },
  {
    name: "掛金納付対象職員届提出について",
    path: "/SCRC080001",
    component: SCRC080001,
    meta: {
      title: "掛金納付対象職員届提出について",
    },
  },
  {
    name: "掛金納付対象職員届提出時の事前確認",
    path: "/SCRC080002",
    component: SCRC080002,
    meta: {
      title: "掛金納付対象職員届提出時の事前確認",
      contextName: "job_11",
    },
  },
  {
    name: "掛金納付延長申請　内容入力",
    path: "/SCRC080009",
    component: SCRC080009,
    meta: {
      title: "掛金納付延長申請　内容入力",
    },
  },
  {
    name: "施設の登録内容の確認",
    path: "/SCRC050030",
    component: SCRC050030,
    meta: {
      title: "施設の登録内容の確認",
    },
  },
  {
    name: "掛金情報確認 施設一覧",
    path: "/SCRC080006",
    component: SCRC080006,
    meta: {
      title: "掛金情報確認 施設一覧",
      contextName: "job_01,job_11,searchForHistory",
    },
  },
  {
    name: "職員情報",
    path: "/SCRC080105",
    component: SCRC080105,
    meta: {
      title: "職員情報",
      contextName: "job_11,job_15,job_23,job_114,agentRequest",
    },
  },
  {
    name: "掛金納付対象職員届の提出確認",
    path: "/SCRC080103",
    component: SCRC080103,
    meta: {
      title: "掛金納付対象職員届の提出確認",
      contextName: "job_01,job_11",
    },
  },
  {
    name: "職員の登録内容の確認",
    path: "/SCRC060033",
    component: SCRC060033,
    meta: {
      title: "職員の登録内容の確認",
      contextName: "job_11,job_15,job_23,agentRequest",
    },
  },
  {
    name: "職員一覧　配置換え登録（施設新設）",
    path: "/SCRC060111",
    component: SCRC060111,
    meta: {
      title: "職員一覧　配置換え登録（施設新設）",
      contextName: "job_15,job_11",
    },
  },
  {
    name: "施設転換後非加入　新規登録",
    path: "/SCRC050018",
    component: SCRC050018,
    meta: {
      title: "施設転換後非加入　新規登録",
    },
  },
  {
    name: "措置入所障害児職員数、特定職員数の見込数変更申請",
    path: "/SCRC050029",
    component: SCRC050029,
    meta: {
      title: "措置入所障害児職員数、特定職員数の見込数変更申請",
      contextName: "job_20,job_11,searchForHistory",
    },
  },
  {
    name: "施設等新設届の職員情報登録",
    path: "/SCRC050103",
    component: SCRC050103,
    meta: {
      title: "施設等新設届の職員情報登録",
      contextName: "job_11,job_15",
    },
  },
  {
    name: "登録メールアドレスの変更届",
    path: "/SCRC010004",
    component: SCRC010004,
    meta: {
      title: "登録メールアドレスの変更届",
    },
  },
  {
    name: "育児休業情報登録",
    path: "/SCRC060101",
    component: SCRC060101,
    meta: {
      title: "育児休業情報登録",
      contextName:
        "job_01,job_03,job_04,job_10,job_11,job_15,job_16,job_23,job_24,job_25,job_29,job_32,childcareLeave,employeeStatusUpdate,retirement,agentRequest",
    },
  },
  {
    name: "部分解除　施設選択",
    path: "/SCRC050125",
    component: SCRC050125,
    meta: {
      title: "部分解除　施設選択",
      contextName: "job_16",
    },
  },
  {
    name: "契約解除（中小企業退職金共済契約締結）内容入力",
    path: "/SCRC050110",
    component: SCRC050110,
    meta: {
      title: "契約解除（中小企業退職金共済契約締結）内容入力",
      contextName: "job_03",
    },
  },
  {
    name: " 契約解除（中退共済契約締結）入力内容確認",
    path: "/SCRC050012",
    component: SCRC050012,
    meta: {
      title: " 契約解除（中退共済契約締結）入力内容確認",
      contextName: "job_03,searchForHistory",
    },
  },
  {
    name: "育児休業情報確認",
    path: "/SCRC060102",
    component: SCRC060102,
    meta: {
      title: "育児休業情報確認",
      contextName:
        "job_01,job_03,job_04,job_10,job_11,job_15,job_16,job_23,job_24,job_25,job_29,job_32,childcareLeave,employeeStatusUpdate,retirement,agentRequest",
    },
  },
  {
    name: "部分解除対象施設一覧",
    path: "/SCRC050126",
    component: SCRC050126,
    meta: {
      title: "部分解除対象施設一覧",
      contextName: "job_16",
    },
  },
  {
    name: "従業状況確認",
    path: "/SCRC050111",
    component: SCRC050111,
    meta: {
      title: "従業状況確認",
      contextName: "job_03,job_04,job_16,searchForHome",
    },
  },
  {
    name: "退職情報　登録（本俸月額の登録）",
    path: "/SCRC060123",
    component: SCRC060123,
    meta: {
      title: "退職情報　登録（本俸月額の登録）",
      contextName: "job_32,retirement,agentRequest",
    },
  },
  {
    name: "廃止・休止・経営移管施設一覧",
    path: "/SCRC050121",
    component: SCRC050121,
    meta: {
      title: "廃止・休止・経営移管施設一覧",
      contextName: "job_11,job_18",
    },
  },
  {
    name: "従業状況の更新　施設一覧",
    path: "/SCRC050114",
    component: SCRC050114,
    meta: {
      title: "従業状況の更新　施設一覧",
      contextName: "job_04,job_03",
    },
  },
  {
    name: "非加入の取下げ登録",
    path: "/SCRC050019",
    component: SCRC050019,
    meta: {
      title: "非加入の取下げ登録",
      contextName: "job_22",
    },
  },
  {
    name: "退職情報　登録時の事前確認",
    path: "/SCRC060119",
    component: SCRC060119,
    meta: {
      title: "退職情報　登録時の事前確認",
      contextName: "job_32,agentRequest",
    },
  },
  {
    name: "振込先口座情報入力",
    path: "/SCRC070105",
    component: SCRC070105,
    meta: {
      title: "振込先口座情報入力",
      contextName: "groupApply,searchForHome,searchForHistory",
    },
  },
  {
    name: "廃止・休止・経営移管施設選択",
    path: "/SCRC050120",
    component: SCRC050120,
    meta: {
      title: "廃止・休止・経営移管施設選択",
      contextName: "job_11,job_18",
    },
  },
  {
    name: "加入登録手続き",
    path: "/SCRC060110",
    component: SCRC060110,
    meta: {
      title: "加入登録手続き",
      contextName: "job_11,agentRequest,searchForHistory",
    },
  },
  {
    name: "加入登録手続き",
    path: "/SCRC060108",
    component: SCRC060108,
    meta: {
      title: "加入登録手続き",
      contextName: "job_01,job_11,job_15,job_23,agentRequest,searchForHome",
    },
  },
  {
    name: "退職届の取り下げ",
    path: "/SCRC060132",
    component: SCRC060132,
    meta: {
      title: "退職届の取り下げ",
      contextName: "job_34,retirement,searchForHome,searchForHistory",
    },
  },
  {
    name: "退職予定者一覧",
    path: "/SCRC060118",
    component: SCRC060118,
    meta: {
      title: "退職予定者一覧",
      contextName: "job_32,newContractInfo,retirement,agentRequest",
    },
  },
  {
    name: "申請情報詳細（職員情報）一覧",
    path: "/SCRC070003",
    component: SCRC070003,
    meta: {
      title: "申請情報詳細（職員情報）一覧",
      contextName: "job_23,agentRequest",
    },
  },
  {
    name: "配置換え　内容入力",
    path: "/SCRC060104",
    component: SCRC060104,
    meta: {
      title: "配置換え　内容入力",
      contextName: "job_11,job_27,agentRequest",
    },
  },
  {
    name: "登録方法選択",
    path: "/SCRC070007",
    component: SCRC070007,
    meta: {
      title: "登録方法選択",
    },
  },
  {
    name: "施設等新設届の提出確認",
    path: "/SCRC050105",
    component: SCRC050105,
    meta: {
      title: "施設等新設届の提出確認",
      contextName: "job_15",
    },
  },
  {
    name: "新規登録職員一覧",
    path: "/SCRC050104",
    component: SCRC050104,
    meta: {
      title: "新規登録職員一覧",
      contextName: "job_11,job_15",
    },
  },
  {
    name: "職員の異動状況登録",
    path: "/SCRC050123",
    component: SCRC050123,
    meta: {
      title: "職員の異動状況登録",
    },
  },
  {
    name: "申請情報詳細（新規契約）",
    path: "/SCRC070002",
    component: SCRC070002,
    meta: {
      title: "申請情報詳細（新規契約）",
    },
  },
  {
    name: "申請情報詳細（新設届）",
    path: "/SCRC070104",
    component: SCRC070104,
    meta: {
      title: "申請情報詳細（新設届）",
      contextName: "job_15,searchForHistory",
    },
  },
  {
    name: "契約解除（加入者全員の同意）　内容入力",
    path: "/SCRC050113",
    component: SCRC050113,
    meta: {
      title: "契約解除（加入者全員の同意）　内容入力",
      contextName: "job_04",
    },
  },
  {
    name: "職員情報新規登録",
    path: "/SCRC060106",
    component: SCRC060106,
    meta: {
      title: "職員情報新規登録",
      contextName: "job_01",
    },
  },
  {
    name: "掛金納付対象職員届の提出確認詳細",
    path: "/SCRC080104",
    component: SCRC080104,
    meta: {
      title: "掛金納付対象職員届の提出確認詳細",
      contextName: "job_11",
    },
  },
  {
    name: "契約者基本情報　更新",
    path: "/SCRC040002",
    component: SCRC040002,
    meta: {
      title: "契約者基本情報　更新",
      contextName: "job_01,searchForHistory",
    },
  },
  {
    name: "退職者識別コード",
    path: "/SCRC060129",
    component: SCRC060129,
    meta: {
      title: "退職者識別コード",
      contextName: "job_36,retirement,agentRequest,searchForRetirement",
    },
  },
  {
    name: "退職情報　登録（退職手当金支払いの順番の登録）",
    path: "/SCRC060124",
    component: SCRC060124,
    meta: {
      title: "退職情報　登録（退職手当金支払いの順番の登録）",
      contextName: "job_32,retirement,agentRequest",
    },
  },
  {
    name: "職員照会",
    path: "/SCRC060017",
    component: SCRC060017,
    meta: {
      title: "職員照会",
      contextName: "job_11,job_15,job_23,agentRequest",
    },
  },
  {
    name: "都道府県社会福祉協議会等への掛金納付対象職員届データの提供の同意について",
    path: "/SCRC080008",
    component: SCRC080008,
    meta: {
      title:
        "都道府県社会福祉協議会等への掛金納付対象職員届データの提供の同意について",
    },
  },
  {
    name: "契約解除（経営者でなくなった）対象職員一覧",
    path: "/SCRC050108",
    component: SCRC050108,
    meta: {
      title: "契約解除（経営者でなくなった）対象職員一覧",
    },
  },
  {
    name: "契約解除（加入者全員の同意）　入力内容確認",
    path: "/SCRC050016",
    component: SCRC050016,
    meta: {
      title: "契約解除（加入者全員の同意）　入力内容確認",
      contextName: "job_04,searchForHistory",
    },
  },
  {
    name: " 廃止・休止・経営移管施設情報登録",
    path: "/SCRC050122",
    component: SCRC050122,
    meta: {
      title: " 廃止・休止・経営移管施設情報登録",
      contextName: "job_11,job_18",
    },
  },
  {
    name: " 廃止・休止・経営移管施設内容確認",
    path: "/SCRC050024",
    component: SCRC050024,
    meta: {
      title: " 廃止・休止・経営移管施設内容確認",
      contextName: "job_11,job_18,searchForHistory",
    },
  },
  {
    name: "マニュアル等",
    path: "/SCRC020002",
    component: SCRC020002,
    meta: {
      title: "マニュアル等",
      contextName: "",
    },
  },
  {
    name: "共済契約対象外施設への異動情報",
    path: "/SCRC060115",
    component: SCRC060115,
    meta: {
      title: "共済契約対象外施設への異動情報",
      contextName:
        "job_11,job_27,job_29,agentRequest,searchForHistory,searchForHome",
    },
  },
  {
    name: "加入登録手続き　内容確認",
    path: "/SCRC060009",
    component: SCRC060009,
    meta: {
      title: "加入登録手続き　内容確認",
      contextName: "job_01,job_11,job_15,job_23,agentRequest",
    },
  },
  {
    name: "退職情報　登録（添付書類の確認）",
    path: "/SCRC060121",
    component: SCRC060121,
    meta: {
      title: "退職情報　登録（添付書類の確認）",
      contextName: "job_32,retirement,agentRequest",
    },
  },
  {
    name: "共済契約対象施設への復帰情報",
    path: "/SCRC060114",
    component: SCRC060114,
    meta: {
      title: "共済契約対象施設への復帰情報",
      contextName:
        "job_11,job_27,job_28,agentRequest,searchForHistory,searchForHome",
    },
  },
  {
    name: "パスワード変更申請",
    path: "/SCRC010002",
    component: SCRC010002,
    meta: {
      title: "パスワード変更申請",
    },
  },
  {
    name: "退職情報 登録",
    path: "/SCRC060120",
    component: SCRC060120,
    meta: {
      title: "退職情報 登録",
      contextName: "job_32,retirement,agentRequest,searchForHistory",
    },
  },

  {
    name: "引継ぎコード",
    path: "/SCRC060130",
    component: SCRC060130,
    meta: {
      title: "引継ぎコード",
    },
  },
  {
    name: "退職情報　登録（従業状況の確認）",
    path: "/SCRC060122",
    component: SCRC060122,
    meta: {
      title: "退職情報　登録（従業状況の確認）",
      contextName: "job_32,retirement,agentRequest",
    },
  },
  {
    name: "退職手当金支給予定額の証明依頼書",
    path: "/SCRC060134",
    component: SCRC060134,
    meta: {
      title: "退職手当金支給予定額の証明依頼書",
    },
  },
  {
    name: "掛金納付対象職員届提出控え、振込依頼書ダウンロード",
    path: "/SCRC080007",
    component: SCRC080007,
    meta: {
      title: "掛金納付対象職員届提出控え、振込依頼書ダウンロード",
      contextName: "job_79,searchForHistory",
    },
  },
  {
    name: "従業状況更新",
    path: "/SCRC060112",
    component: SCRC060112,
    meta: {
      title: "従業状況更新",
      contextName:
        "job_03,job_25,job_32,job_11,employeeStatusUpdate,agentRequest,searchForHistory",
    },
  },
  {
    name: "共済契約対象（外）施設等異動　対象者一覧",
    path: "/SCRC060013",
    component: SCRC060013,
    meta: {
      title: "共済契約対象（外）施設等異動　対象者一覧",
      contextName: "job_11,job_27,agentRequest,searchForHistory",
    },
  },
  {
    name: "すべての手続履歴一覧",
    path: "/SCRC070101",
    component: SCRC070101,
    meta: {
      title: "すべての手続履歴一覧",
    },
  },
  {
    name: "代行処理依頼詳細",
    path: "/SCRC100004",
    component: SCRC100004,
    meta: {
      title: "代行処理依頼詳細",
      contextName: "agentRequest",
    },
  },
];

export { routes };
